import React from 'react'
import SignupComponent from '../../Components/Auth/SignupComponent'
import Layout from '../../Components/Layout/Layout'

const Signup = () => {
  return (
    <>
     <Layout>
        <SignupComponent />
     </Layout>
    </>
  )
}

export default Signup